'use client';

import { AD_SETTINGS } from '@/lib/adSlots';
import AdHeader from '../AdHeader';
import TravelpayoutsWidget from './TravelpayoutsWidget';

export default function TravelpayoutsRentalCarsAd() {
  const src =
    `https://tpwidg.com/content?currency=${AD_SETTINGS.currency}` +
    `&trs=${AD_SETTINGS.trs}` +
    `&shmarker=${AD_SETTINGS.shmarker}` +
    `&locale=${AD_SETTINGS.locale}` +
    `&powered_by=false` +
    `&bg_color=%23FFFFFFff&font_color=%23333333&button_color=%2300a200` +
    `&button_font_color=%23ffffff&button_text=Search&rounded_corners=false` +
    `&benefits=false&dc_powered_by=false&supplier_logos=true&top_logo=false` +
    `&logo_style=dark&top_color=%23007ac2&campaign_id=117&promo_id=3873`;

  return (
    <div>
      <AdHeader title="Find a rental car nearby" />
      <TravelpayoutsWidget src={src} />
    </div>
  );
}
